import { render, staticRenderFns } from "./Clue1.vue?vue&type=template&id=ab67c0b2&lang=pug&"
import script from "./Clue1.vue?vue&type=script&lang=js&"
export * from "./Clue1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports